export enum TableNameKeys {
    number = 'number',
    tonnage = 'tonnage', // заявленный тоннаж - сколько нужно привезти по заказу
    tonnageFact = 'unLoadTonnageFact', // фактический тоннаж - это сколько привез водитель по заказу
    customer = 'customerName',
    author = 'author',
    supplier = 'supplier',
    unLoadingPoint = 'outpoint',
    brand = 'brand',
    equipment = 'equipment',
    driver = 'driver',
    customerStatus = 'customerStatus',
    driverStatus = 'driver_status',
    unloadDate = 'unloadingBeginDate',
    loadDateFact = 'loadingDateFact',
    unloadDateFact = 'unLoadingDateFact',
    createdAt = 'createdAt',
    comment = 'comment',
}